export default {
    more: "- read more",
}
